/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import { useSelector } from "react-redux";
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import TagForm from './TagForm';
import * as validations from '../../validations/validations';
import * as tagActions from '../../actions/tagActions';
 
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";

import { Segment} from 'semantic-ui-react'; 
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment'; 
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
 import {getMargenes} from '../../util/';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as menuActions from '../../actions/menuActions';
import withRouter from '../common/withRouter';
import * as paginaActions from '../../actions/paginaActions';

class ManageTagForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            strings:[],
            permisos:{},
			tag:{}
		};
	}
    
    
    componentDidMount(){
        usuarioActual(this, "tag",true).then( (usuario)=>{
           let id=this.props.id;
        
            if(id && id>0 ){
            
                this.props.tagActions.getTag(id, usuario).then( tag=>{
                   this.setState({"tag":tag});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
		
        
		
    }
    

    handleChange=(event, data)=> {

        let tag = this.state.tag;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		tag[field[0]]= value;
		else{
             if(!tag[field[0]]){
                    tag[field[0]]={}
                }
			tag[field[0]][field[1]]= value;
		}
        
		
        this.setState({"tag": tag});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let tag=this.state.tag;
              
        if(!validations.requerido(tag.descripcion)){
            errors.tag=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.tagActions.save(this.state.tag, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
            
        });
        
    }

       
    render() {	
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
        return (
              <Segment  style={margenes}>
                <TagForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.tag}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        color:state.color,
        permisos:state.permisos,
        user:state.user,
        idioma:state.idioma,
        form:state.form,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
        menuActions: bindActionCreators(menuActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        tagActions: bindActionCreators(tagActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageTagForm));